import React, { useEffect, useState } from 'react';

import { Alert } from '@change/ds-core-ui';

import { useMediaHitsContext } from '../../../../shared/context';

export const MediaSubmitMessages: React.FC<EmptyProps> = () => {
	const [showMessage, setShowMessage] = useState(false);

	const {
		data: { submitStatus },
		actions: { setSubmitStatus },
	} = useMediaHitsContext();

	useEffect(() => {
		if (submitStatus) {
			// eslint-disable-next-line react-hooks/set-state-in-effect
			setShowMessage(true);
		} else {
			setShowMessage(false);
		}
	}, [submitStatus]);

	const handleClose = () => {
		setShowMessage(false);
		setSubmitStatus(undefined);
	};

	if (!showMessage) return null;

	return (
		<div className="my-4">
			{submitStatus === 'success' && (
				<Alert variant="success" onDismissClick={handleClose} dismissButtonAriaLabel="Dismiss">
					{/* TODO i18n: hardcoded, not run through the translation system */}
					Media hit added
				</Alert>
			)}
			{submitStatus === 'error' && (
				<Alert variant="error" onDismissClick={handleClose} dismissButtonAriaLabel="Dismiss">
					{/* TODO i18n: hardcoded, not run through the translation system */}
					Something went wrong
				</Alert>
			)}
			{submitStatus === 'invalid-link' && (
				<Alert variant="error" onDismissClick={handleClose} dismissButtonAriaLabel="Dismiss">
					{/* TODO i18n: hardcoded, not run through the translation system */}
					That doesn't look like a valid link. Please check the URL and try again.
				</Alert>
			)}
		</div>
	);
};
